import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type {
  StockAlertCloseAction,
  StockAlertCloseResult,
  StockAlertProcessAction,
  StockAlertProcessResult,
  StockAlertQuery,
  StockAlertRow,
  StockAlertScanResult,
  StockAlertSummary
} from '../types/stockAlert';

/** 库存/效期预警：列表、汇总、规则扫描、关闭闭环。 */
export function createStockAlertApi(http: HttpClient) {
  return {
    list(query: StockAlertQuery = {}): Promise<PageResult<StockAlertRow>> {
      return http.request<PageResult<StockAlertRow>>({ path: '/wl/stock-alert', query: toQuery(query) });
    },
    summary(): Promise<StockAlertSummary> {
      return http.request<StockAlertSummary>({ path: '/wl/stock-alert/summary' });
    },
    /** 规则扫描（回看 days 天内的效期），默认 30 天。 */
    scan(days = 30): Promise<StockAlertScanResult> {
      return http.request<StockAlertScanResult>({
        path: '/wl/stock-alert/scan',
        method: 'POST',
        query: toQuery({ days })
      });
    },
    /** 认领/处理中：NEW → PROCESSING，落 al_handle 处理记录。 */
    process(
      id: string,
      actionType: StockAlertProcessAction = 'ACK',
      desc?: string,
      linkBizNo?: string
    ): Promise<StockAlertProcessResult> {
      return http.request<StockAlertProcessResult>({
        path: `/wl/stock-alert/${id}/process`,
        method: 'POST',
        body: { actionType, desc, linkBizNo }
      });
    },
    close(id: string, result: StockAlertCloseAction = 'RESOLVED', remark?: string): Promise<StockAlertCloseResult> {
      return http.request<StockAlertCloseResult>({
        path: `/wl/stock-alert/${id}/close`,
        method: 'POST',
        body: { result, remark }
      });
    }
  };
}

export type StockAlertApi = ReturnType<typeof createStockAlertApi>;
